function getEventTarget(evnt) {
  const target = evnt.target
  if (target && target.shadowRoot && evnt.composed) {
    return evnt.composedPath()[0]
  }
  return target
}

/**
 * 检查触发源是否属于目标节点
 */
function getEventTargetNode(evnt, container, className) {
  let targetElem
  let target = getEventTarget(evnt)
  const rootEl = document.documentElement || document.querySelector('html')
  while (target && target.nodeType && target !== rootEl) {
    if (
      className &&
      target.className &&
      target.className.split &&
      target.className.split(' ').indexOf(className) > -1
    ) {
      targetElem = target
    } else if (target === container) {
      return { flag: className ? !!targetElem : true, container, targetElem: targetElem }
    }
    target = target.parentElement
  }
  return { flag: false }
}

/**
 * 事件兼容性处理
 */
function handleClearEvent(params) {
  const { $event } = params
  const bodyElem = document.body
  if (
    // 远程搜索
    getEventTargetNode($event, bodyElem, 'el-autocomplete-suggestion').flag ||
    // 下拉框
    getEventTargetNode($event, bodyElem, 'el-select-dropdown').flag ||
    // 级联
    getEventTargetNode($event, bodyElem, 'el-cascader__dropdown').flag ||
    getEventTargetNode($event, bodyElem, 'el-cascader-menus').flag ||
    // 日期
    getEventTargetNode($event, bodyElem, 'el-time-panel').flag ||
    getEventTargetNode($event, bodyElem, 'el-picker-panel').flag ||
    // 颜色
    getEventTargetNode($event, bodyElem, 'el-color-dropdown').flag
  ) {
    return false
  }
}

export function VxeTablePluginRenderElement(interceptor) {
  interceptor.add('event.clearFilter', handleClearEvent)
  interceptor.add('event.clearEdit', handleClearEvent)
  interceptor.add('event.clearAreas', handleClearEvent)
  // 兼容老版本
  interceptor.add('event.clearActived', handleClearEvent)
}
